import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import ViewImage from './ViewImage';

import {
	StyledInputWithLabel,
} from 'lib/styles';

import {
	Container,
	Wrapper,
	Image,
	ImageDescription,
	InputContainer,
} from './styles'

class BuildingImages extends React.Component {
	state = {
	  filter: '',
	  viewImage: false,
	}

	viewImageHandler = viewImage => this.setState({ viewImage });

	render() {
	  const { t, images } = this.props;
	  const viewImage = images.find(image => image.file === this.state.viewImage) || false;

	  return (
	    <React.Fragment>
	      <InputContainer>
	        <StyledInputWithLabel
	          type="text"
	          value={this.state.filter}
	          label={t('building/images/filter')}
	          onChange={e => this.setState({ filter: e.target.value })}
	        />
	      </InputContainer>
	      <Container>
	        {
	          images
	            .filter(image => {
	              if (this.state.filter === '') {
	                return true;
	              }

	              return image.name.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1;
	            })
	            .sort((a,b) => {
	              const aMuoto = a.meta.muoto;
	              const bMuoto = b.meta.muoto;

	              return aMuoto > bMuoto ? 1 : aMuoto < bMuoto ? -1 : 0;
	            }).map((image, i) => {
	              const paddingBottom = image.aspect * 100;
	              const url = image ? image.conversions.min : '';

	              return (
	                <Wrapper key={i}>
	                  <Image
	                    onClick={() => this.viewImageHandler(image.file)}
	                    style={{
	                      paddingBottom: `${paddingBottom}%`,
	                      backgroundImage: `url(${url})`,
	                    }}
	                  >
	                    <ImageDescription>{image.name}</ImageDescription>
	                  </Image>
	                </Wrapper>
	              )}
	            )
	        }
	      </Container>
	      <ViewImage closeHandler={() => this.viewImageHandler(false)} image={viewImage} t={t} />
	    </React.Fragment>
	  )
	}
}

BuildingImages.propTypes = {
	t: PropTypes.func,
	images: PropTypes.array,
	buildingId: PropTypes.number,
	match: PropTypes.object,
}

BuildingImages.defaultProps = {
	images: [],
	buildingId: null,
}

export default translate('translations')(BuildingImages)
